<template>
  <div class="layerWrapper active" style="display: block;" tabindex="0">
    <div class="cbox layerBox popWidM" ref="layerBox"
      :style="{'display': 'block', 'opacity': '1', ...style}">
      <div class="cart-popup__dialog">
        <div class="cart-popup__content payment">
          <div class="cart-popup__item-info amway-theme" style="padding:0;">
            
           
            <div v-if="wave_number === 1" >              
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_01-1.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_01-2.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_01-3.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_01-4.jpg" alt="액티비티 안내">              
            </div>
            <div v-if="wave_number === 2" >              
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_02-1.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_02-2.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_02-3.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_02-4.jpg" alt="액티비티 안내">              
            </div>
            <div v-if="wave_number === 3" >              
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_03-1.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_03-2.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_03-3.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_03-4.jpg" alt="액티비티 안내">              
            </div>
            <div v-if="wave_number === 4" >              
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_04-1.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_04-2.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_04-3.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_04-4.jpg" alt="액티비티 안내">              
            </div>
            <div v-if="wave_number === 5" >              
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_05-1.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_05-2.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_05-3.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_05-4.jpg" alt="액티비티 안내">              
            </div>
            <div v-if="wave_number === 6" >              
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_06-1.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_06-2.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_06-3.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_06-4.jpg" alt="액티비티 안내">              
            </div>
            <div v-if="wave_number === 7" >              
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_07-1.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_07-2.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_07-3.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_07-4.jpg" alt="액티비티 안내">              
            </div>
            <div v-if="wave_number === 8" >              
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_08-1.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_08-2.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_08-3.jpg" alt="액티비티 안내">
              <img src="@/views/surveys/sydney/images/activity/activity_sdy_08-4.jpg" alt="액티비티 안내">              
            </div>
          </div>
        </div>
        <div
          class="cart-popup__item-link" style="border:none;">
          <a @click="closePopup" class="bt-akl-blue btn_close NCAcmi_cont03_popup">확인</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SURVEY_SYDNEY, TOGGLE_ACTIVITY_POPUP } from '@/store/actions/survey'
import { PopupMixin } from '../mixins'

export default {
  name: 'SurveyPopupLayerActivity',
  mixins: [PopupMixin],
  computed: {
    ...mapState(SURVEY_SYDNEY, {
      pinLevel: state => state.pin_level,
      show: state => state.popup_activity,
      wave_number: state => state.wave_number
    }),
    ...mapGetters(SURVEY_SYDNEY, {
    }),
  },
  watch: {
    show(isOpen) {
      if(isOpen) {
        this.htmlEl.classList.add("scrollLock");
        this.uiLayerMask.classList.add("on");
        this.uiLayerMask.style.display = 'block';
        window.addEventListener('resize', this.layerTypeBasic);
        this.layerTypeBasic();
      } else {
        this.htmlEl.classList.remove("scrollLock");
        this.uiLayerMask.classList.remove("on");
        this.uiLayerMask.style.display = 'none';
        window.removeEventListener('resize', this.layerTypeBasic);
      }
    }
  },
  methods: {
    closePopup() {
      this.$store.commit(`${SURVEY_SYDNEY}/${TOGGLE_ACTIVITY_POPUP}`, false);
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyPopupLayerActivity.vue